import { render } from "./FormElementIbanField.vue?vue&type=template&id=c8c09dc0&ts=true"
import script from "./FormElementIbanField.vue?vue&type=script&lang=ts"
export * from "./FormElementIbanField.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__